import { useLocation, useOutletContext } from 'react-router-dom'

import { TrainingMembershipsDataTableQuery } from 'generated/resources/datatable.graphql'
import compact from 'lodash/compact'

import { useDataTable } from 'modules/core/components/DataTable'

import { AddToClassModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddToClassModal'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

interface LocationState {
  selectedAccessIds?: number[]
}

const isLocationState = (state: unknown): state is LocationState => {
  return (
    typeof state === 'object' &&
    state !== null &&
    ('selectedAccessIds' in state || Object.keys(state).length === 0)
  )
}

const AssignParticipantsWithOneCollection = () => {
  const location = useLocation()
  const selectedAccessIds = isLocationState(location.state)
    ? location.state.selectedAccessIds ?? []
    : []
  return <AddToClassModal accessIds={selectedAccessIds} />
}

const AssignParticipantsWithDataTable = () => {
  const data = useDataTable<TrainingMembershipsDataTableQuery>()
  const selectedAccessIds = compact(
    data.queryResult.data?.trainings.trainingMembershipsConnection.edges.map((membership) => {
      if (data.selectedRows.has(String(membership.node?.id))) {
        return membership.node?.accessId
      }
    })
  )

  return <AddToClassModal accessIds={selectedAccessIds} />
}

const AssignParticipants = () => {
  const context = useOutletContext<DetailOutletContext>()

  if (!context) {
    return null
  }

  const { hasParticipantOneDataCollection } = context

  return hasParticipantOneDataCollection ? (
    <AssignParticipantsWithOneCollection />
  ) : (
    <AssignParticipantsWithDataTable />
  )
}

export default AssignParticipants
